import { render, staticRenderFns } from "./arrowOptions.vue?vue&type=template&id=5ca411ac&scoped=true&lang=pug&"
import script from "./arrowOptions.vue?vue&type=script&lang=js&"
export * from "./arrowOptions.vue?vue&type=script&lang=js&"
import style0 from "./arrowOptions.vue?vue&type=style&index=0&id=5ca411ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca411ac",
  null
  
)

export default component.exports